import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PhysicianAccountPgpsDTO, TableColumn } from '@mynexus/mynexus-ui-lib';

@Component({
    selector: 'auth-provider-select',
    templateUrl: './auth-provider-select.component.html',
    styleUrls: ['./auth-provider-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuthProviderSelectComponent implements OnInit {
  @Input() providers: PhysicianAccountPgpsDTO[] = [];
  @Input() providerTitle: string;

  @Output() selected = new EventEmitter<number>();

  cols: TableColumn[];

  ngOnInit(): void {
    this.cols = [
      new TableColumn(`${this.providerTitle} Provider Name`, 'accountName'),
      new TableColumn('Address', 'physicalStreet'),
      new TableColumn('City', 'physicalCity'),
      new TableColumn('State', 'physicalState'),
      new TableColumn('ZIP Code', 'physicalZip'),
      new TableColumn('Phone', 'phone'),
    ];
  }

  selectProvider(index: number): void {
    this.selected.emit(index);
  }
}
